import {capitalizeTheFirstLetterOfEachWord} from '@/utils/helpers'

export const popularServicesMapping = {
    66: {
        ico: 'mdi-pool',
        title: 'serviceNames.pool',
    },
    71: {
        ico: 'mdi-pool',
        title: 'serviceNames.pool',
    },
    5: {
        ico: 'mdi-air-conditioner',
        title: 'serviceNames.air_conditioning',
    },
    68: {
        ico: 'mdi-parking',
        title: 'serviceNames.parking',
    },
    42: {
        ico: 'mdi-parking',
        title: 'serviceNames.parking',
    },
    79: {
        ico: 'mdi-spa',
        title: 'serviceNames.spa',
    },
    228: {
        ico: 'mdi-briefcase-variant',
        title: 'serviceNames.business_center',
    },
    76: {
        ico: 'mdi-silverware',
        title: 'serviceNames.restaurant',
    },
    179: {
        ico: 'mdi-wifi',
        title: 'serviceNames.internet',
    },
    217: {
        ico: 'mdi-human-male-female',
        title: 'serviceNames.adults_only',
    },
}

export const servicesTransformer = (hotelServices, addValueToFilter, roomOffers) => {
    const services = {
        services: [],
        otaCodeServices: [],
        popularServices: [],
        roomServices: [],
    }
    hotelServices.forEach(({/*otaName,*/ /*groupName*/ standardName, supplierServiceName, otaCode, groupName}) => {
        //TODO OTA mapping issues http://ota-dictionary.ru/codelist/HAC otaName != supplierServiceName
        const name = capitalizeTheFirstLetterOfEachWord(standardName || supplierServiceName)
        if (name) {
            addValueToFilter('services', name, groupName)
            services.services.push(name)
        }
        if (otaCode) {
            services.otaCodeServices.push({name, otaCode})

            if (popularServicesMapping[otaCode]) {
                services.popularServices.push(name)
                addValueToFilter('popularServices', name)
            }
        }

        roomOffers.forEach(({roomServices}) => {
            if (!roomServices) return
            roomServices.forEach(name => {
                if (!services.roomServices.includes(name)) {
                    addValueToFilter('roomServices', name)
                    services.roomServices.push(name)
                }
            })
        })
    })
    return services
}

export const distanceTransformer = distance => {
    if (distance <= 1) return 'a_less_than_1'
    if (distance <= 2) return 'b_less_than_2'
    if (distance <= 3) return 'c_less_than_3'
    if (distance <= 5) return 'd_less_than_5'

    return 'e_more_than_5'
}

export const distanceAdapter = distance => {
    const list = []
    if (distance <= 1) list.push('a_less_than_1')
    if (distance <= 2) list.push('b_less_than_2')
    if (distance <= 3) list.push('c_less_than_3')
    if (distance <= 5) list.push('d_less_than_5')
    if (distance > 5) list.push('e_more_than_5')

    return list
}

export const supplierRatingAdapter = count => {
    if (count >= 9) return 'a_superb'
    else if (count >= 8) return 'b_very_good'
    else if (count >= 7) return 'c_good'
    else if (count >= 6) return 'd_pleasant'

    return 'e_other'
}

export const ratingByClientsFeedbackAdapter = count => {
    if (count >= 9) return 'a_superb'
    else if (count >= 8) return 'b_very_good'
    else if (count >= 7) return 'c_good'
    else if (count >= 6) return 'd_pleasant'
    else if (count >= 0) return 'e_other'
}

export const addCustomFilters = () => {}
